/**
 * テナント自身の処分事業者
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../../../constants/httpConst'
 
 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/tenants/disposals`
 
 const search_tenant_disposal = {
   namespaced: true,
   state: {},
   getters: {},
   actions: {
     index () {
       return new Promise((resolve) => {
         Vue.$http.get(API_PATH).then(data => {
           resolve(data.content)
         })
       })
     },
   },
   mutations: {},
 }
 export default search_tenant_disposal
 